import { useRouter } from "next/router";
import {
  Navigation,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { portalRoutes } from "@nju/routes";
import { BlockContent, GeneralErrorNotification, LayoutWrapper } from "@nju/ui";

export default function ReactivationSuccess() {
  const router = useRouter();

  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="primary">
        <RequiredDashboardData extendedMode="base">
          <Navigation title="moja usługa" />
          <GeneralErrorNotification
            callback={() => {
              router.push(portalRoutes.mojeKonto.index.get({ mode: "ftth" }));
            }}
          />
        </RequiredDashboardData>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
